var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTransferFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_transferFunds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_transferFunds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6977778,10.6555556 C9.92333333,9.93444444 9.03111111,9.18888889 9.03111111,8.02777778 C9.03111111,6.69555556 10.2655556,5.76666667 12.3311111,5.76666667 C14.5066667,5.76666667 15.3133333,6.80555556 15.3866667,8.33333333 L18.0877778,8.33333333 C18.0022222,6.23111111 16.7188889,4.3 14.1644444,3.67666667 L14.1644444,1 L10.4977778,1 L10.4977778,3.64 C8.12666667,4.15333333 6.22,5.69333333 6.22,8.05222222 C6.22,10.8755556 8.55444444,12.2811111 11.9644444,13.1 C15.02,13.8333333 15.6311111,14.9088889 15.6311111,16.0455556 C15.6311111,16.8888889 15.0322222,18.2333333 12.3311111,18.2333333 C9.81333333,18.2333333 8.82333333,17.1088889 8.68888889,15.6666667 L6,15.6666667 C6.14666667,18.3433333 8.15111111,19.8466667 10.4977778,20.3477778 L10.4977778,23 L14.1644444,23 L14.1644444,20.3722222 C16.5477778,19.92 18.4422222,18.5388889 18.4422222,16.0333333 C18.4422222,12.5622222 15.4722222,11.3766667 12.6977778,10.6555556 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransferFunds);
export default __webpack_public_path__ + "static/media/ic_transferFunds.a8b2475642307804dc189ce5ff6b5bcb.svg";
export { ForwardRef as ReactComponent };